/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildDto } from '../../models/child-dto';

export interface AdminChildControllerFindAll$Params {

/**
 * 아동 성별
 */
  gender?: 'MALE' | 'FEMALE';

/**
 * 아동 생년월일
 */
  birthStart?: string;

/**
 * 아동 생년월일
 */
  birthEnd?: string;

/**
 * 주보호자
 */
  mainGuardianIds?: Array<string>;

/**
 * 등록일자
 */
  createdAtStart?: string;

/**
 * 등록일자
 */
  createdAtEnd?: string;

/**
 * 소속 센터
 */
  centerIds?: Array<string>;
}

export function adminChildControllerFindAll(http: HttpClient, rootUrl: string, params?: AdminChildControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ChildDto>>> {
  const rb = new RequestBuilder(rootUrl, adminChildControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('gender', params.gender, {});
    rb.query('birthStart', params.birthStart, {});
    rb.query('birthEnd', params.birthEnd, {});
    rb.query('mainGuardianIds', params.mainGuardianIds, {});
    rb.query('createdAtStart', params.createdAtStart, {});
    rb.query('createdAtEnd', params.createdAtEnd, {});
    rb.query('centerIds', params.centerIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ChildDto>>;
    })
  );
}

adminChildControllerFindAll.PATH = '/api/child/admin';
